import fs from 'fs';
import path from 'path';
import dotenv from 'dotenv';
import {BasicKeys} from "@/utils/persistent";
import {APP_LOCAL_CACHE_KEY, APP_SESSION_CACHE_KEY, CacheTypeEnum} from "@/enums/cacheEnum";
import {toRaw} from "vue";
import router from "@/router";
import dayjs from 'dayjs'
import {getFileAccessHttpUrl} from "@/utils/common/compUtils";




const isLocal = CacheTypeEnum.LOCAL;

export function isDevFn(mode: string): boolean {
  return mode === 'development';
}

export function isProdFn(mode: string): boolean {
  return mode === 'production';
}

/**
 * Whether to generate package preview
 */
export function isReportMode(): boolean {
  return process.env.REPORT === 'true';
}

// Read all environment variable configuration files to process.env
export function wrapperEnv(envConf: Recordable): ViteEnv {
  const ret: any = {};

  for (const envName of Object.keys(envConf)) {
    let realName = envConf[envName].replace(/\\n/g, '\n');
    realName = realName === 'true' ? true : realName === 'false' ? false : realName;

    if (envName === 'VITE_PORT') {
      realName = Number(realName);
    }
    if (envName === 'VITE_PROXY' && realName) {
      try {
        realName = JSON.parse(realName.replace(/'/g, '"'));
      } catch (error) {
        realName = '';
      }
    }
    ret[envName] = realName;
    if (typeof realName === 'string') {
      process.env[envName] = realName;
    } else if (typeof realName === 'object') {
      process.env[envName] = JSON.stringify(realName);
    }
  }
  return ret;
}

/**
 * 获取当前环境下生效的配置文件名
 */
function getConfFiles() {
  const script = process.env.npm_lifecycle_script;
  // update-begin--author:liaozhiyang---date:20240326---for：【QQYUN-8690】修正获取当前环境下的文件名
  const reg = new RegExp('NODE_ENV=([a-z_\\d]+)');
  // update-end--author:liaozhiyang---date:20240326---for：【QQYUN-8690】修正获取当前环境下的文件名
  const result = reg.exec(script as string) as any;
  if (result) {
    const mode = result[1] as string;
    return ['.env', `.env.${mode}`];
  }
  return ['.env', '.env.production'];
}

/**
 * Get the environment variables starting with the specified prefix
 * @param match prefix
 * @param confFiles ext
 */
export function getEnvConfig(match = 'VITE_GLOB_', confFiles = getConfFiles()) {
  let envConfig = {};
  confFiles.forEach((item) => {
    try {
      const env = dotenv.parse(fs.readFileSync(path.resolve(process.cwd(), item)));
      envConfig = { ...envConfig, ...env };
    } catch (e) {
      console.error(`Error in parsing ${item}`, e);
    }
  });
  const reg = new RegExp(`^(${match})`);
  Object.keys(envConfig).forEach((key) => {
    if (!reg.test(key)) {
      Reflect.deleteProperty(envConfig, key);
    }
  });
  return envConfig;
}

export function setAuthCache(key: BasicKeys, value) {
 localStorage.setItem(key, value)
}
export function getAuthCache<T>(key: BasicKeys) {
  return localStorage.getItem(key)
}
export function delAuthCache<T>(key: BasicKeys) {
  return localStorage.removeItem(key)
}

export function go(uri){
  router.push({ name: uri })
}

export function noUseBzzq(startDate, newStartDate, endDate){
  //通过现在时间，开始时间，结束时间计算 保单当前还有多久
  let start = dayjs(startDate);
  let end = dayjs(newStartDate);
  let use = end.diff(start, 'day');

  console.log("保单开始时间")
  console.log(start.format("YYYY-MM-DD HH:mm:ss"))
  console.log("当前时间")
  console.log(end.format("YYYY-MM-DD HH:mm:ss"))
  console.log("已经使用天数：" + use)

  console.log("保单结束时间")
  console.log(endDate.format("YYYY-MM-DD HH:mm:ss"))
  let ed = dayjs(endDate).diff(start, 'day')+1;
  //整个周期多少天
  console.log("整个周期天数：" + ed)

  return 1-(use/ed);
}


export function noUseBzzqMonth(startDate, newStartDate){
  //通过现在时间，开始时间，结束时间计算 保单当前还有多久
  let start = dayjs(startDate);
  let end = dayjs(newStartDate).add(1, 'day');
  console.log("用户选择批改时间")
  console.log(start.format("YYYY-MM-DD 00:00:00"))
  console.log("保单结束时间")
  console.log(end.format("YYYY-MM-DD 00:00:00"))

  let use = end.diff(start, 'month');
  console.log("还剩余月份数：" + use)
  return use;
}

export function noUseBzzqMonthAdd(startDate, newStartDate){
  //通过现在时间，开始时间，结束时间计算 保单当前还有多久
  let start = dayjs(startDate);
  let end = dayjs(newStartDate);
  console.log("用户选择批改时间")
  console.log(start.format("YYYY-MM-DD 00:00:00"))
  console.log("保单结束时间")
  console.log(end.format("YYYY-MM-DD 00:00:00"))

  let use = end.diff(start, 'month', true);
  console.log("还剩余月份数：" + use)
  return Math.ceil(use);
}

export function objectCopy(newData, data){
  for(let index in newData){
    if(data.hasOwnProperty(index)){
      newData[index] = data[index]
    }
  }
}

export function getBetweenText(min, max, text, sp = '-'){
  let arr = Array.from(new Set([min, max,]))
  return arr.join(sp) + text
}

export function removeSpaces(str) {
  return str.replace(/\s+/g, '');
}

/**
 * 文件下载
 */
export function downloadFile(url) {
  if (url.indexOf(',') > 0) {
    url = url.substring(0, url.indexOf(','));
  }
  url = getFileAccessHttpUrl(url.split(',')[0]);
  if (url) {
    window.open(url);
  }
}


/**
 * 金额自动追加两位小数，且使用千分位符号
 */
export function amountFormat(amount) {
  return amount.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}
